const styles = {
  cellText: {
    color: 'primary.greyMetal',
    fontSize: '18px',
    fontWeight: 500,
  },
};

export default styles;
